export default {
    namespaced: true,
    state: () => ({
      dataWebsitePortal2: null,
    }),
    mutations: {
      SET_DATA_WEBSITE_PORTAL2(state, payload) {
        state.dataWebsitePortal2 = payload.dataWebsitePortal2
      },
    },
    actions: {
      storeDataWebsitePortal2({ commit }, payload) {
        commit('SET_DATA_WEBSITE_PORTAL2', payload)
      },
    },
    getters: {
      hasPortalData: (state) => !!state.dataWebsitePortal2,
    },
  }
  